import { render, staticRenderFns } from "./InactivationListTab.vue?vue&type=template&id=c668719a&"
import script from "./InactivationListTab.vue?vue&type=script&lang=js&"
export * from "./InactivationListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports